var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-image-wrap pb-40 pb-lg-60"
  }, [_c('div', {
    staticClass: "image-bg w-100"
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_c('div', {
    class: _vm.className + ' w-100 bg-grey-light'
  })])], 1), _c('div', {
    staticClass: "bg-image-content"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "align-md-center align-lg-start"
  }, [_c('v-col', {
    staticClass: "mb-12 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "lg": "6"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto mx-md-0",
    attrs: {
      "src": _vm.src,
      "max-width": "535"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "pt-lg-24 pt-xl-54"
  }, [_vm._t("default")], 2)])], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }